import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import getReopenInspectionMutationRequest from './get-reopen-inspection-mutation-request'

import { IUseUpdateMutation, IUpdateFn } from '../../interfaces'

const useReopenInspectionMutation: IUseUpdateMutation<undefined, undefined> = (params, options = {}) => {
  const request = useMemo(() => getReopenInspectionMutationRequest(params), [params])

  const reopenInspection: IUpdateFn<number | undefined, undefined> = useCallback(
    async id => {
      const _request =
        typeof id === 'number' ? getReopenInspectionMutationRequest({ airportId: params.airportId, id }) : request
      return axios(_request).then(res => res.data)
    },
    [request, params.airportId],
  )

  const response = useMutation<undefined, Error, undefined>({
    mutationFn: reopenInspection,
    ...options,
  })

  return response
}

export default useReopenInspectionMutation
